import { UserAvatar } from "../user-avatar";
import type { UserAvatarByEmailViewModel } from "./types-user-avatar-by-email";

export function UserAvatarByEmailView(props: UserAvatarByEmailViewModel) {
  return <UserAvatar {...props} />;
}
